import React, { useContext, useCallback } from 'react';

import Spreadsheet from 'react-spreadsheet';

import { useFormattedTableData, updateChillerLogFieldIfChanged } from '../../../utils/highlightedDataUtil';

import { ChillerCompressor } from '../../model';
import { ChillerLogsContext } from '../contexts/ChillerLogsContext';

interface CompressorDetailsSubsectionProps {
  compressor: ChillerCompressor;
  col: number;
}

const CompressorDetailsSubsection: React.FunctionComponent<CompressorDetailsSubsectionProps> = (props) => {
  const { chillerLog, setChillerLog, saveCurrentLogToLocalStorage, currentLogApproved } =
    useContext(ChillerLogsContext);

  let { compressor, col } = props;

  let classes = 'chiller-spreadsheet';
  if (col === 3) {
    classes += ' third-column';
  }

  let readIndex = compressor?.index + 1;
  let tableData = useFormattedTableData(compressor?.compressor_details, col, currentLogApproved);
  let columnLabels = ['', '', '', `Comp ${readIndex}`];

  const handleSpreadsheetChange = useCallback(
    (updatedData) => {
      updateChillerLogFieldIfChanged({
        chillerLog,
        setChillerLog,
        updatedData,
        currentFieldValue: compressor.compressor_details,
        getField: (log) => log.circuits[compressor.circuit_index].compressors[compressor.index].compressor_details,
        setField: (log, value) => {
          log.circuits[compressor.circuit_index].compressors[compressor.index].compressor_details = value;
        },
      });
    },
    [setChillerLog, chillerLog],
  );

  return (
    compressor?.compressor_details?.length > 0 && (
      <Spreadsheet
        data={tableData}
        hideRowIndicators
        columnLabels={[columnLabels[col]]}
        onChange={handleSpreadsheetChange}
        className={classes}
        onBlur={saveCurrentLogToLocalStorage}
      />
    )
  );
};

export default CompressorDetailsSubsection;
